<template>
    <b-container>
        <b-row>
            <b-col sm="12">
                File
                <existing-file-list :files="content.existing_product_sharing" />
                <div id="product_sharing" class="dropzone dropzone-area mb-3">
                    <div class="dz-message">
                        Drop files here or click button to upload. <br />(Max. size 350MB)
                    </div>
                </div>
            </b-col>
        </b-row>
        <b-modal
        id="modal-login"
        cancel-variant="outline-secondary"
        ok-title="Ok"
        cancel-title="Close"
        centered
        title="Name"
        ref="nameModal"
        @ok="setCurrentFile"
        >
        <b-form @submit.prevent="setCurrentFile(); $refs.nameModal.hide();">
            <b-form-group>
            <label for="name">Name:</label>
            <b-form-input
                id="name"
                placeholder="Name File"
                v-model="currentFileName"
            />
            </b-form-group>
        </b-form>
        </b-modal>
    </b-container>
</template>

<script>
import { BTabs, BTab } from 'bootstrap-vue'
import { BModal } from 'bootstrap-vue'
import { BLink, BImg, BContainer, BRow, BCol, BCard, BForm, BFormGroup, BFormInput, BButton, BProgress, BCardText, BDropdown, BDropdownItem, BOverlay, BBadge } from 'bootstrap-vue'

// eslint-disable-next-line
import 'quill/dist/quill.core.css'
// eslint-disable-next-line
import 'quill/dist/quill.snow.css'
// eslint-disable-next-line
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'

import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import ExistingFileList from './ExistingFileList.vue'
export default {
    props: {
        content: Object,
        options: Object,
        methods: Object,
        dropzoneElements: Object,
    },
    components: {
        BCardText,
        BTabs,
        BTab,
        BLink,
        BImg,
        BCol,
        BContainer,
        BRow,
        BCard,
        BProgress,
        BCardText,
        BDropdown,
        BDropdownItem,
        BButton,
        BForm,
        BFormGroup,
        BFormInput,
        BOverlay,
        BModal,
        BBadge,
        vSelect,
        quillEditor,
        ExistingFileList,
    },
    directives: {
        Ripple,
    },
    data() {
        return {
            currentFile: '',
            currentFileName: '',
            product_sharing: null,
        }
    },
    mounted() {
        let vm = this
        let options = {
                url: process.env.VUE_APP_API_URL + '/dummy',
                maxFiles: 1,
                autoProcessQueue: true,
                autoQueue: true,
                addRemoveLinks: true,
                maxFilesize:350,
                accept: function (file, done) {
                    let mapContainerId = 'map_'+this.element.id
                    vm.mapContainerId = mapContainerId
                    vm.currentFile = file
                    vm.showMsgBoxName()
                    file.accepted = true
                    file.status = 'success'
                    this.emit('success', file)
                    this.emit('complete', file)
                }
            
            }
        this.dropzoneElements.product_sharing = new Dropzone("#product_sharing", options)
    },
    methods: {
        syncMedia() {
            this.content.product_sharing = this.dropzoneElements.product_sharing.getAcceptedFiles()
        },
        showMsgBoxName() {
            let vm = this
            vm.$refs.nameModal.show()
        },
        setCurrentFile() {
            let file = {
                name: this.currentFileName,
                file: this.currentFile
            }
            this.content[this.mapContainerId] = [...this.content[this.mapContainerId], file]
            this.currentFile = ''
            this.currentFileName = ''
        },
    }
}
</script>

<style scoped>
.dropzone {
    min-height: 250px;
}
/deep/ .dz-message:before {
    display: none;
}

.desc {
    color: #b8c2cc;
    font-size: 0.7rem;
    font-style: italic;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>